import { render, staticRenderFns } from "./tabMaterialsApparatus.vue?vue&type=template&id=5669cb20&scoped=true&"
import script from "./tabMaterialsApparatus.vue?vue&type=script&lang=js&"
export * from "./tabMaterialsApparatus.vue?vue&type=script&lang=js&"
import style0 from "./tabMaterialsApparatus.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tabMaterialsApparatus.vue?vue&type=style&index=1&id=5669cb20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5669cb20",
  null
  
)

export default component.exports